import React from 'react';
import styled from 'styled-components';
import * as tokens from 'styles';
import { media } from 'styles/mixins';
import { getDuoSubLandingPageLeftPhoneSource } from 'lib/localized-assets';
import { getDuoSubLandingPageRightPhoneSource } from 'lib/localized-assets';
import SectionHeadline from 'components/SubLandingPage/SectionHeadline';
import LeadParagraph from 'components/SubLandingPage/LeadParagraph';
import { useTranslation } from 'data/translation/useTranslation';

const SectionListenTogether = styled.section.attrs({ id: 'phoneDisplay' })`
  background-color: ${tokens.gray95};
  color: ${tokens.black};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow: hidden;

  ${media.mobileSmUp} {
    display: block;
    position: relative;
  }
  ${media.desktopLgUp} {
    overflow: inherit;
  }
`;

const TextWrapper = styled.div`
  padding: ${tokens.spacer64} ${tokens.spacer32} ${tokens.spacer12};
  margin: 0 auto 1em;
  ${media.mobileSmUp} {
    min-height: 375px;
    max-width: 458px;
    margin: 0 auto;
    padding-bottom: ${tokens.spacer64};
    > p {
      font-size: ${tokens.spacer24};
    }
  }
  ${media.desktopLgUp} {
    max-width: 548px;
  }
  > h3 {
    padding-bottom: 0;
  }
`;

type PhoneImageProps = {
  $src: string;
  $position: 'left' | 'right';
};

const PhoneImage = styled.div<PhoneImageProps>`
  width: 46%;
  height: 340px;
  background-image: url(${props => props.$src});
  background-position: ${props =>
      props.$position === 'left' ? 'right' : 'left'}
    top;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-block;
  ${media.mobileSmUp} {
    position: absolute;
    background-size: contain;
    bottom: 0px;
    ${props => props.$position}: calc(50vw - 282px - 458px * 0.5);
    width: 292px;
    height: 380px;
  }
  ${media.desktopLgUp} {
    ${props => props.$position}: calc(50vw - 326px - 548px * 0.5);
    width: 326px;
    height: 424px;
  }
`;

const PhoneDisplay = () => {
  const { locale, t } = useTranslation();
  return (
    <SectionListenTogether>
      <TextWrapper>
        {/* eslint-disable @spotify-internal/wtb-rules/no-danger-styled */}
        <SectionHeadline
          paddingBottom={tokens.spacer24}
          dangerouslySetInnerHTML={{
            __html: t('sub_landing_page.listen_together_separately'),
          }}
        />
        <LeadParagraph>
          {t('sub_landing_page.two_separate_accounts')}
        </LeadParagraph>
      </TextWrapper>
      <PhoneImage
        $src={getDuoSubLandingPageLeftPhoneSource(locale)}
        $position="left"
      />
      <PhoneImage
        $src={getDuoSubLandingPageRightPhoneSource(locale)}
        $position="right"
      />
    </SectionListenTogether>
  );
};

export default PhoneDisplay;
